import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { VUE_APP_SIT_API_URL } from "@/commons/config";
import Viagem from "@/models/viagem";

export class ViagemAPI extends BaseAPI<Viagem> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}/autorizacoesFretamento`;
  }

  public createViagem(viagem: Viagem): AxiosObservable<Viagem> {
    return this.axios.post(`${this.apiUrl}/viagem`, { viagem });
  }
  public getAllViagens(
    autorizacaoFretamentoId: number
  ): AxiosObservable<Viagem[]> {
    return this.axios.post(`${this.apiUrl}/viagens`, {
      autorizacaoFretamentoId
    });
  }
  public removeViagem(id: number): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/removerViagem`, { viagem: { id } });
  }
}
